
const m = window.require("discourse/lib/escape");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
